import Wrapper from 'landing_pages/components/wrapper';
import { withRouter } from 'react-router';
import { getProjectIdFromUrl } from 'project/utils';
import { fetchProjectIfNeeded } from 'project/ducks/project';
import { fetchPageIfNeeded } from 'landing_pages/ducks';

Wrapper.need = [
  params => fetchPageIfNeeded(params.pageSlug, params.subcategory),
  params => fetchProjectIfNeeded({ projectId: getProjectIdFromUrl(params) }),
];

export default withRouter(Wrapper);



// WEBPACK FOOTER //
// ./landing_pages/containers/wrapper.js